import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { ref, computed } from "vue";
import type { Placement } from "@popperjs/core/lib/enums";
import { useOnClickOutside } from "@/composables";
import PopUp from "@/components/utils/PopUp.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PopupButton',
  props: {
    placement: {},
    offset: {},
    forceShow: { type: Boolean },
    renderOnShow: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const button = ref<HTMLElement | null>(null);
const root = ref<HTMLElement | null>(null);
const showPopup = ref(false);
const finalShow = computed(() => showPopup.value || (props.forceShow ?? false));

useOnClickOutside(root, () => (showPopup.value = false));

__expose({ show: (on: boolean) => (showPopup.value = on) });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root
  }, [
    _createElementVNode("div", {
      ref_key: "button",
      ref: button,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showPopup.value = !showPopup.value))
    }, [
      _renderSlot(_ctx.$slots, "button")
    ], 512),
    (!_ctx.renderOnShow || finalShow.value)
      ? (_openBlock(), _createBlock(PopUp, {
          key: 0,
          show: finalShow.value,
          placement: _ctx.placement,
          offset: _ctx.offset,
          reference: button.value
        }, {
          default: _withCtx((slotProps) => [
            _renderSlot(_ctx.$slots, "popup", {
              visible: finalShow.value,
              forceUpdate: slotProps.forceUpdate
            })
          ]),
          _: 3
        }, 8, ["show", "placement", "offset", "reference"]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})